import { type FC, type PropsWithChildren } from 'react'

import styled from '@emotion/styled'

const StyledPageContainer = styled.div`
  padding: 24px 30px;
`

const StyledLayoutContainer = styled.div`
  min-width: 730px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  margin: 0 auto;
`

interface PageContainerProps {
  className?: string
  'data-mu-test'?: string
}

const PageContainer: FC<PropsWithChildren<PageContainerProps>> = ({
  children,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <StyledPageContainer className={className} data-mu-test={dataAttributeTest}>
      <StyledLayoutContainer>{children}</StyledLayoutContainer>
    </StyledPageContainer>
  )
}

export default PageContainer
